<ng-template #modal_otp let-c="close" let-d="dismiss">
    <div class="alert-modal" [ngClass]="{'mox-style': claim.isMox()}">
    <div *ngIf="!showCloseIcon"><br/></div>
    <div *ngIf="showCloseIcon" class="div-otp-close">
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true" *ngIf="!claim.isMox()">&times;</span>
            <div [ngClass]="{'mox-ui-popup-close mox-ui-popup-close-pos-relative mox-ui-popup-close-sm': claim.isMox()}" *ngIf="claim.isMox()">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </button>
    </div>
    <div class="modal-body" [ngClass]="{'mox-ui-otp-modal-body': claim.isMox()}">
        <div class="otp-title" [ngClass]="{'mox-ui-text-20 mox-ui-otp-head-title': claim.isMox()}">{{ 'otpBox.label' | translate }}</div>
        <h4 [ngClass]="{'mox-ui-text-14 mox-ui-otp-head-description': claim.isMox()}">{{ (otpSms ? 'otpBox.messageSms' : 'otpBox.message') | translate }} {{maskedEmailAddress}}</h4><br/>
        <div>
            <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" *ngIf="showOtpComponent" [config]="config" ></ng-otp-input>
        </div>
        <div *ngIf="showOtpError" >
            <small id="error-message">{{'otpBox.errorMessage' | translate}}</small>
        </div>
        <div class="mt-4" [ngClass]="{'mox-ui-otp-wrapper mox-ui-text-center': claim.isMox()}">
            <div *ngIf="showResendOtpLink" [ngClass]="{'mox-ui-text-14': claim.isMox()}">
                <div class="content d-flex justify-content-center align-items-center"> 
                    <span>{{ 'otpBox.resendQuestion' | translate }}</span>
                </div>
                <div *ngIf="this.timeLeft > 0" disabled class="content d-flex justify-content-center align-items-center resend-disabled"> 
                    <a class="text-decoration-none ms-3">
                        {{ 'otpBox.resend' | translate }} ({{timeLeft}})</a>
                </div>
                <div *ngIf="this.timeLeft === 0" class="content d-flex justify-content-center align-items-center resend-enabled"> 
                    <a href="javascript:;" (click)="onSendOtp()"class="text-decoration-none ms-3">
                        {{ 'otpBox.resend' | translate }}</a>
                </div>
            </div>
            <br/><br/>
            <button class="new-btn btn-primary btn" [ngClass]="{'continue-disabled' : this.otp.length !== 6}"
                [disabled]="this.otp.length !== 6" 
                (click)="onVerifyOtp();" [ngClass]="{'mox-ui-btn mox-ui-btn-width mox-ui-btn-height mox-ui-btn-after mox-ui-btn-rm-style': claim.isMox()}">
                    {{'claimSection.generalLabels.generalButtonLabels.continue' | translate}}
            </button>
        </div>
        <br/><br/>
    </div>
    </div>
</ng-template>

<ng-template #modal_otp_locked let-c="close" let-d="dismiss">
    <div class="alert-modal" [ngClass]="{'mox-style': claim.isMox()}">
    <div class="modal-body">
        <div class="otp-title" [ngClass]="{'mox-ui-text-20 mox-ui-otp-head-title mox-ui-text-center': claim.isMox()}">{{ 'otpBox.locked' | translate }}</div><br/>
        <h4 [ngClass]="{'mox-ui-text-14 mox-ui-otp-head-descriptio': claim.isMox()}">{{ 'otpBox.lockedSublabel' | translate }}</h4>
    </div>
    <div class="mt-4" [ngClass]="{'mox-ui-otp-wrapper': claim.isMox()}">
        <button class="new-btn btn-primary btn" (click)="c('Close click')" [ngClass]="{'mox-ui-btn mox-ui-btn-width mox-ui-btn-height mox-ui-btn-after mox-ui-btn-rm-style': claim.isMox()}">
                {{'claimSection.generalLabels.generalButtonLabels.continue' | translate}}
        </button>
        <br/><br/>
    </div>
    </div>
</ng-template>